<template>
  <div v-if="isShow">
    <header>
      初デートで行きたい場所を編集
      <div class="h-left">
        <a @click="$emit('close')"><img src="~@/assets/images/icon02.svg" /></a>
      </div>
    </header>
    <div id="wrap">
      <div class="txt-area">
        <p class="b">初デートで行きたい場所</p>
        <textarea v-model="formData.value" class="self-introduction1" placeholder="記入する" :maxlength="maxLength"></textarea
        >
        <div class="clearfix">
          <div class="self-introduction3">{{lengthContent}}/{{maxLength}}</div>
        </div>
      </div>
      <div :class="formData.value ? 'btn1' : 'btn3'"><a @click="$emit('submit', formData.value)">保存</a></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isShow: Boolean,
    value: String,
  },
  emits: ['close'],
  data: () => ({
    formData: {
      value: null,
    },
    maxLength: 100
  }),
  computed: {
    lengthContent() {
        if (this.formData.value)
            return this.formData.value.length
            
        return 0
    }
  },
  mounted() {
    this.formData.value = this.value;
  },
  methods: {},
};
</script>